export default "__VITE_ASSET__CenOJvpS__"